import React from 'react';
import TableColumnTitle from '../../../../../components/_table/TableColumnTitle';
import OpenProductDetail from '../../../../../components/link/OpenProductDetail';
import OpenReviewDetail from '../../../../../components/link/OpenReviewDetail';
import OpenOrderItemDetail from '../../../../../components/link/OpenOrderItemDetail';
import OpenUserDetail from '../../../../../components/link/OpenUserDetail';
import TableColumnImg from '../../../../../components/table/TableColumnImg';
import OpenPreviewProductDetail from '../../../../../containers/app/common/OpenPreviewProductDetail';
import { setDateFormat } from '../../../../../lib/moment';

/**
 *  추천 상품 후기에 연결된 상품 후기 아이템 리스트 컬럼
 */
export const columns = () => {
  return [
    {
      title: <TableColumnTitle title={'이미지'} />,
      dataIndex: 'url',
      render: (value) => <TableColumnImg url={value} width={'60px'} height={'60px'} />,
    },
    {
      title: <TableColumnTitle title={'별점'} />,
      dataIndex: 'rate',
    },
    {
      title: <TableColumnTitle title={'상품 후기 번호'} />,
      dataIndex: 'id',
      render: (value) => <OpenReviewDetail text={value} reviewId={value} />,
    },
    {
      title: <TableColumnTitle title={'상품 번호'} />,
      dataIndex: 'productId',
      render: (value) => <OpenProductDetail text={value} productId={value} />,
    },
    {
      title: <TableColumnTitle title={'상품명'} />,
      dataIndex: 'productName',
      render: (value, record) => <OpenPreviewProductDetail text={value} productId={record.productId} />,
    },
    {
      title: <TableColumnTitle title={'상품 주문번호'} />,
      dataIndex: 'orderItemId',
      render: (value) => <OpenOrderItemDetail text={value} orderItemId={value} />,
    },
    {
      title: <TableColumnTitle title={'구매자 ID'} />,
      dataIndex: 'buyerId',
      render: (value, record) => <OpenUserDetail text={value} userId={record.userId} />,
    },
    {
      title: <TableColumnTitle title={'구매자명'} />,
      dataIndex: 'buyerName',
    },
    {
      title: <TableColumnTitle title={'구매평'} />,
      className: 'contents',
      dataIndex: 'content',
    },
    {
      title: <TableColumnTitle title={'작성 일자'} />,
      dataIndex: 'createDate',
      render: (value) => setDateFormat(value),
    },
  ];
};
